import clsx from 'clsx';
import * as React from 'react';

import {
    CUSTOMIZATION_ANNOUNCEMENT_MESSAGE_MAX_LENGTH,
    CUSTOMIZATION_ANNOUNCEMENT_MESSAGE_MIN_LENGTH,
} from '@gitbook/api-client';
import { Description, FieldGroup, Label, TextInput } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../../types';

const MIN_LENGTH = CUSTOMIZATION_ANNOUNCEMENT_MESSAGE_MIN_LENGTH;
const MAX_LENGTH = CUSTOMIZATION_ANNOUNCEMENT_MESSAGE_MAX_LENGTH;

/**
 * Settings to configure the message for the site announcement
 */
export function AnnouncementMessageSettings(
    props: SitesCustomizationPanelProps
): React.ReactElement {
    const { settings, setSettings } = props;
    const [message, setMessage] = React.useState(settings.announcement?.message);
    const [originalSettings] = React.useState(settings);

    return (
        <FieldGroup orientation="vertical">
            <Label>Message</Label>
            <Description>The content of the banner.</Description>
            <TextInput
                value={message}
                placeholder="Version 2 has been released"
                minLength={MIN_LENGTH}
                maxLength={MAX_LENGTH}
                onChange={(event) => {
                    const value = event.target.value;
                    setMessage(value);
                    setSettings((prev) => ({
                        ...prev,
                        announcement: {
                            enabled: true,
                            style: 'info',
                            ...prev.announcement,
                            message:
                                value.length >= MIN_LENGTH && value.length <= MAX_LENGTH
                                    ? value
                                    : (originalSettings.announcement?.message ?? ''),
                        },
                    }));
                }}
            />
            <div
                className={clsx(
                    'text-ui-small',
                    (message?.length ?? 0) < MIN_LENGTH || (message?.length ?? 0) >= MAX_LENGTH
                        ? 'text-danger'
                        : 'text-muted'
                )}
            >
                {message?.length ?? 0} / {MAX_LENGTH} characters
            </div>
        </FieldGroup>
    );
}
